// A media query to reposition and populate sub menus on larger screensizes
const largeBreakpoint = window.matchMedia("(min-width: 1024px)");

// A simple toggle - assuming there is only ever one navbar rendered on the page
function addBurgerMenuToggle() {
  const openMenuElement = document.querySelector(".menu-toggle.show-menu");
  const closeMenuElement = document.querySelector(".menu-toggle.close-menu");
  const topNavMenuContainer = document.querySelector(
    ".menu--go-wild---top-navigation ul.menu"
  );

  openMenuElement.addEventListener("click", (e) => {
    e.preventDefault();
    openMenuElement.classList.add("show");
    closeMenuElement.classList.add("show");
    topNavMenuContainer.classList.add("show");
  });

  closeMenuElement.addEventListener("click", (e) => {
    e.preventDefault();
    openMenuElement.classList.remove("show");
    closeMenuElement.classList.remove("show");
    topNavMenuContainer.classList.remove("show");
  });
}

function changeMenuToggleText() {
  const menuText = Array.from(
    document.querySelectorAll(".menu-toggle.show-menu")
  )[0].firstElementChild;
  menuText.textContent = "More";
}

function revertMenuToggleText() {
  const menuText = Array.from(
    document.querySelectorAll(".menu-toggle.show-menu")
  )[0].firstElementChild;
  menuText.textContent = "Menu";
}

document.addEventListener("DOMContentLoaded", () => {
  addBurgerMenuToggle();
  if (largeBreakpoint.matches) {
    changeMenuToggleText();
  }
});

largeBreakpoint.addEventListener("change", (e) => {
  if (largeBreakpoint.matches) {
    changeMenuToggleText();
  } else {
    revertMenuToggleText();
  }
});
